import React, { useEffect, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import AccountDetailsForm from 'src/pages/accountSettings/components/AccountDetails/AccountDetailsForm';
import AccountDetailsViewer from 'src/pages/accountSettings/components/AccountDetails/AccountDetailsViewer';
import { RootState } from 'src/shared/state/store';
import { Business } from '@models/account';
import {
  AccountSettingsSgaControllersConfiguration,
  AccountSettingsSponsoredAdsControllersConfiguration,
} from '@features/account-settings/constants';
import { ControllerConfigurations } from '@features/account-settings/types';

interface AccountDetailsProps {
  business: Business;
  currency?: string;
  timeZone?: string;
  industry?: string;
}
const AccountDetails = ({
  business,
  currency,
  timeZone,
  industry,
}: AccountDetailsProps) => {
  const methods = useForm({
    mode: 'onBlur',
    defaultValues: {
      business,
      currency,
      timeZone,
      industry,
    },
  });

  /**
   * Update the default value when the form is submitted
   */
  useEffect(() => {
    methods.reset({
      business,
      currency,
      timeZone,
      industry,
    });
  }, [business, currency, timeZone, industry]);

  const { accountInfoEditMode: isEditMode, isSga } = useSelector(
    (state: RootState) => ({
      accountInfoEditMode: state.accountSettings.accountInfoEditMode,
      isSga: state.accountSettings.isSga,
    }),
  );

  const controllerConfiguration: ControllerConfigurations =
    useMemo<ControllerConfigurations>(() => {
      return isSga
        ? AccountSettingsSgaControllersConfiguration
        : AccountSettingsSponsoredAdsControllersConfiguration;
    }, [isSga]);

  return (
    <FormProvider {...methods}>
      {isEditMode ? (
        <AccountDetailsForm configuration={controllerConfiguration} />
      ) : (
        <AccountDetailsViewer />
      )}
    </FormProvider>
  );
};

export default AccountDetails;
